module.exports = require('./lodash');


//////////////////
// WEBPACK FOOTER
// ./~/lodash/index.js
// module id = 1149
// module chunks = 1